import { render } from "./ExpositorSection.vue?vue&type=template&id=001649a9&ts=true"
import script from "./ExpositorSection.vue?vue&type=script&lang=ts"
export * from "./ExpositorSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__